module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_primaerlogo_troms_og_finnmark_pos.0f5ae553.svg";